import { render, staticRenderFns } from "./DetailReview.vue?vue&type=template&id=31f2b878&"
import script from "./DetailReview.vue?vue&type=script&lang=js&"
export * from "./DetailReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports